import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/** @format */

/**
 * External dependencies
 */
import { isNil } from 'lodash';
import { format as d3Format } from 'd3-format';
import { utcParse as d3UTCParse } from 'd3-time-format';
/**
 * Allows an overriding formatter or defaults to d3Format or d3TimeFormat
 * @param {string|function} format - either a format string for the D3 formatters or an overriding fomatting method
 * @param {function} formatter - default d3Format or another formatting method, which accepts the string `format`
 * @returns {function} to be used to format an input given the format and formatter
 */

export var getFormatter = function getFormatter(format) {
  var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : d3Format;
  return typeof format === 'function' ? format : formatter(format);
};
/**
 * Returns an array of unique keys contained in the data.
 * @param {array} data - The chart component's `data` prop.
 * @returns {array} Array of unique keys.
 */

export var getUniqueKeys = function getUniqueKeys(data) {
  var keys = new Set(data.reduce(function (acc, curr) {
    return acc.concat(Object.keys(curr));
  }, []));
  return _toConsumableArray(keys).filter(function (key) {
    return key !== 'date';
  });
};
/**
 * Describes `getOrderedKeys`
 * @param {array} data - The chart component's `data` prop.
 * @returns {array} Array of unique category keys ordered by cumulative total value
 */

export var getOrderedKeys = function getOrderedKeys(data) {
  var keys = getUniqueKeys(data);
  return keys.map(function (key) {
    return {
      key: key,
      focus: true,
      total: data.reduce(function (a, c) {
        return a + c[key].value;
      }, 0),
      visible: true
    };
  }).sort(function (a, b) {
    return b.total - a.total;
  });
};
/**
 * Describes `getUniqueDates`
 * @param {array} data - the chart component's `data` prop.
 * @param {string} dateParser - D3 time format
 * @returns {array} an array of unique date values sorted from earliest to latest
 */

export var getUniqueDates = function getUniqueDates(data, dateParser) {
  var parseDate = d3UTCParse(dateParser);
  var dates = new Set(data.map(function (d) {
    return d.date;
  }));
  return _toConsumableArray(dates).sort(function (a, b) {
    return parseDate(a) - parseDate(b);
  });
};
/**
 * Check whether data is empty.
 * @param {array} data - the chart component's `data` prop.
 * @param {number} baseValue - base value to test data values against.
 * @returns {boolean} `false` if there was at least one data value different than
 * the baseValue.
 */

export var isDataEmpty = function isDataEmpty(data) {
  var baseValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  for (var i = 0; i < data.length; i++) {
    for (var _i = 0, _Object$entries = Object.entries(data[i]); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          item = _Object$entries$_i[1];

      if (key !== 'date' && !isNil(item.value) && item.value !== baseValue) {
        return false;
      }
    }
  }

  return true;
};
//# sourceMappingURL=index.js.map